<template>
  <v-card outlined class="mb-2 horario-batida-card">
    <v-card-text class="d-flex align-center justify-space-between flex-wrap">
      <div>
        <div class="text-subtitle-1 font-weight-bold">{{ item.hora_formatada }}</div>
        <div class="text-caption text--secondary">
          {{ item.data_formatada }} - {{ item.dia_semana }}
        </div>
        <div class="text-caption">
          Status: {{ item.status || "Original" }}
          <span v-if="item.nsr"> | NSR: {{ item.nsr }}</span>
        </div>
      </div>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            small
            color="primary"
            :loading="baixandoComprovante"
            v-bind="attrs"
            v-on="on"
            @click="abrirComprovante"
          >
            <v-icon>mdi-download-circle-outline</v-icon>
          </v-btn>
        </template>
        <span>Baixar comprovante</span>
      </v-tooltip>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "HorarioBatidaCard",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      baixandoComprovante: false,
    };
  },
  methods: {
    async abrirComprovante() {
      try {
        this.baixandoComprovante = true;
        await this.$services.instrutorHorariosService.abrirComprovanteBatida(this.item.id);
      } catch (error) {
        if (this.$handleError) this.$handleError(error);
      } finally {
        this.baixandoComprovante = false;
      }
    },
  },
};
</script>

<style scoped>
.horario-batida-card {
  border-radius: 8px;
}
</style>
